import type { FaireAdvertiserProfileEntity } from "../../entity_types/advertiserProfile";

// Shady Front (b_zyctbsexhf, advertiser -2539497733972920379).
// NEW_ONLY and non-pooled: a single new-customers campaign whose budget has
// been raised fourteen times, $600 → $4,800. Lifetime complete-month metrics
// through Aug 2026.
export const advShadyFront: FaireAdvertiserProfileEntity = {
  token: "adv_shady_front",
  type: "advertiserProfile",
  archetype: "budget-capped",
  displayName: "Shady Front",
  brandToken: "b_zyctbsexhf",
  audienceType: "NEW_ONLY",
  globalStatus: "ACTIVE",
  tenureMonths: 23,
  budget: {
    totalBudgetDollars: 4800,
    spendingMode: "MODERATE",
    nextRenewsAtDate: "2026-10-01",
    nextBillsAtDate: "2026-10-04",
  },
  overview: {
    numCustomersAcquired: 391,
    numReorderConversions: 0,
    numTotalConversions: 391,
    totalAdsSalesDollars: 256895,
    newCustomerAdsSalesDollars: 256895,
    reorderAdsSalesDollars: 0,
    totalAdsSpendDollars: 31487,
    newCustomerAdsSpendDollars: 31487,
    reorderAdsSpendDollars: 0,
    newCustomerBestEstimateFirstYearRoas: 9.6,
    reorderRoas: 0,
    combinedFirstYearRoas: 9.6,
    numNewCustomerAdsOrders: 1055,
    numReorderAdsOrders: 0,
  },
  availableCredit: { totalRemainingDollars: 0 },
  budgetRecommendations: {
    newCustomer: {
      minRecommendedBudgetDollars: 3600,
      maxRecommendedBudgetDollars: 5600,
      isEligibleForIncreaseRec: false,
    },
  },
  campaignTokens: ["camp_sf_new"],
  overviewPerformancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-09-27T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
